export default {
  bind (el, {value}) {
    try {
      el.onmousedown = function (downEvent) {
        let disX = downEvent.pageX - el.offsetLeft
        let disY = downEvent.pageY - el.offsetTop
        document.onmousemove = function (moveEvent) {
          let left = moveEvent.pageX - disX
          let maxLeft = window.innerWidth - el.clientWidth
          left >= maxLeft && (left = maxLeft)
          left <= 0 && (left = 0)
          let top = moveEvent.pageY - disY
          let maxTop = window.innerHeight - el.clientHeight
          top >= maxTop && (top = maxTop)
          top <= 0 && (top = 0)
          el.style.left = left + 'px'
          el.style.top = top + 'px'
        }
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null
        }
      }
    } catch (error) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/drag.js